
import IndexModelTable from '@/views/paginas/sigap/modelos/IndexModelTable.vue';
import CardRh from "@/components/cards/ManzaCard.vue";
import MatriculaService from "@/service/v1/sigap/MatriculaService";
import { Options } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { PerfilConfig } from "@/core/config/PerfisConfig";

@Options({
    name: "QuantidadeDependenciaIndex",
    components: { CardRh, KDataTable },
})
export default class QuantidadeDependenciaIndex extends IndexModelTable {
    public turmaId: any = null;
    public aluno_id: any = null;
    public search = '';
    public pelotao = '';

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = '';
        this.pelotao = '';
        this.refreshTable();
    }

    created() {
        this.service = new MatriculaService();
        this.turmaId = this.$route.params.id;
        this.config.ajax = {
            url: this.service.getApiUrl() + '/Dependencia',
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    turmaId: this.turmaId,
                    pelotao: this.pelotao,
                    search: this.search,
                };
                return dados;
            }
        };
        this.config.order = [[0, 'asc']];
        this.config.columns = [
            { data: 'usuario.nome', name: 'usuario' },
            { data: 'pelotao', name: 'pelotao', class: 'text-center' },
            { data: 'quantidadeDependencia', name: 'quantidadeDependencia', class: 'text-center', searchable: false },
        ];
        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs = [
                {
                    targets: 3,
                    render: (row, type, val) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-show-reprovacao-aluno ' + buttom + ' title="Visualizar"><i class="fa fa-eye"></i></button>';
                        return texto;
                    },
                },
            ];
        }
    }

    public tableatualizada() {
        $('[btn-show-reprovacao-aluno]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            window.open('/#/sigap/matricula/' + id + '/reprovacao', '_blank');
        });
    }
}
